module.exports = __webpack_public_path__ + "img/heart_opaque.9cb354a0.svg";